
import { Vue, Component, Prop } from 'vue-property-decorator'
import Store from '@/store'
import ProductForm from '@/components/ProductComponents/ProductForm.vue'

@Component({
  components: {
    ProductForm
  }
})
export default class DropDevice extends Vue {
  public dialogDrop = false
  public valid = true
  public loading = false

  @Prop()
  public readonly value!: any

  onClickClose() {
    this.dialogDrop = false
  }

  public async handleDisable() {
    await Store.commit('openGroup/mutate', {
      property: 'devices.openDeviceId',
      with: this.value
    })

    await Store.dispatch('openGroup/disableDeviceFromGroup')
    Store.dispatch('openGroup/fetchDevices', () => true)
  }
}
